import { PublicProfile } from "./PublicProfile";

class User extends PublicProfile {}

export { User };
